import { createRoute, lazyRouteComponent } from "@tanstack/react-router"
import { webappRoute } from "./layout"

export const readingsRoute = createRoute({
  getParentRoute: () => webappRoute,
  path: "/readings",
  component: lazyRouteComponent(() => import("./lazy-pages"), "LiveChatPage"),
})
